import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface StakeInputProps {
  stake: string;
  onStakeChange: (value: string) => void;
  onClaimKing: () => void;
  isLoading: boolean;
  isConnected: boolean;
}

export const StakeInput = ({ 
  stake, 
  onStakeChange, 
  onClaimKing, 
  isLoading, 
  isConnected 
}: StakeInputProps) => {
  const handleStakeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      onStakeChange(value);
    }
  };

  return (
    <div className="flex gap-2">
      <Input
        type="text"
        placeholder="Enter your stake in MATIC"
        value={stake}
        onChange={handleStakeChange}
        className="flex-1"
        disabled={isLoading}
      />
      <Button
        onClick={onClaimKing}
        className="min-w-[120px]"
        disabled={!isConnected || isLoading}
      >
        {isLoading ? "Claiming..." : "Claim King"}
      </Button>
    </div>
  );
};